(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  var instances = new WeakMap();

  function initialize(section) {
    if (instances.has(section)) return;

    var tabs = section.querySelector('.fine-jewelry-slide');
    var track = section.querySelector('.featured-collections-bar');
    if (!track) return;
    if (!tabs) {
      track.hidden = true;
      return;
    }

    var bar = track.querySelector('.progress-bar');
    var spacing = track.querySelector('.spacing');
    if (!bar || !spacing) return;

    var frame = null;
    var disposed = false;

    function update() {
      frame = null;
      if (disposed) return;

      var totalWidth = tabs.scrollWidth;
      var visibleWidth = tabs.clientWidth;
      var maxScroll = Math.max(0, totalWidth - visibleWidth);
      var offset = Math.min(maxScroll, Math.abs(tabs.scrollLeft));
      var visiblePercent = totalWidth ? Math.min(100, visibleWidth / totalWidth * 100) : 100;

      bar.style.width = visiblePercent + '%';
      spacing.style.width = (totalWidth ? offset / totalWidth * 100 : 0) + '%';
      bar.setAttribute('aria-valuenow', Math.round(maxScroll ? offset / maxScroll * 100 : 100));
    }

    function scheduleUpdate() {
      if (!disposed && frame === null) frame = requestAnimationFrame(update);
    }

    var resizeObserver = null;
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(tabs);
      Array.from(tabs.children).forEach(function (tab) {
        resizeObserver.observe(tab);
      });
    } else {
      window.addEventListener('resize', scheduleUpdate);
    }

    tabs.addEventListener('scroll', scheduleUpdate, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleUpdate);

    instances.set(section, function () {
      disposed = true;
      tabs.removeEventListener('scroll', scheduleUpdate);
      if (resizeObserver) resizeObserver.disconnect();
      else window.removeEventListener('resize', scheduleUpdate);
      if (frame !== null) cancelAnimationFrame(frame);
      instances.delete(section);
    });

    update();
  }

  function initializeWithin(root) {
    root.querySelectorAll('[data-section-type="featured-collections"]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, { once: true });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-section-type="featured-collections"]').forEach(function (section) {
      var cleanup = instances.get(section);
      if (cleanup) cleanup();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lily_visit_us"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lily-visit-us')) {
    class LilyVisitUs extends HTMLElement {
      connectedCallback() {
        this.cancelInitialisation = false;
        const start = () => {
          if (this.cancelInitialisation || !this.isConnected) return;
          this.startStatus();
        };
        if (document.readyState === 'loading') {
          this.readyHandler = start;
          document.addEventListener('DOMContentLoaded', start, { once: true });
        } else {
          queueMicrotask(start);
        }
      }

      disconnectedCallback() {
        this.cancelInitialisation = true;
        clearInterval(this.statusTimer);
        if (this.readyHandler) document.removeEventListener('DOMContentLoaded', this.readyHandler);
      }

      startStatus() {
        clearInterval(this.statusTimer);
        if (this.dataset.statusEnabled !== 'true') return;
        this.statusElement = this.querySelector('[data-lvu-status]');
        this.statusText = this.querySelector('[data-lvu-status-text]');
        if (!this.statusElement || !this.statusText) return;
        this.weeklyHours = Array.from(this.querySelectorAll('[data-lvu-hours]'), row => ({
          days: row.dataset.days.split(',').map(day => day.trim()).filter(day => /^[0-6]$/.test(day)).map(Number),
          closed: row.dataset.closed === 'true',
          opens: row.dataset.opens,
          closes: row.dataset.closes
        }));
        this.specialDates = Array.from(this.querySelectorAll('[data-lvu-special]'), row => ({
          date: row.dataset.date,
          closed: row.dataset.closed === 'true',
          opens: row.dataset.opens,
          closes: row.dataset.closes
        }));
        try {
          this.clock = new Intl.DateTimeFormat('en-GB', {
            timeZone: this.dataset.timeZone || 'Europe/London',
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
          });
          this.updateStatus();
          this.statusTimer = setInterval(() => this.updateStatus(), 60000);
        } catch {
          this.statusElement.hidden = true;
        }
      }

      parseTime(value) {
        if (!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value || '')) return null;
        const [hours, minutes] = value.split(':').map(Number);
        return hours * 60 + minutes;
      }

      intervalsFor(date, weekday) {
        const special = this.specialDates.filter(row => row.date === date);
        const rows = special.length ? special : this.weeklyHours.filter(row => row.days.includes(weekday));
        if (!rows.length) return null;
        const intervals = [];
        for (const row of rows) {
          if (row.closed) continue;
          const start = this.parseTime(row.opens);
          const end = this.parseTime(row.closes);
          if (start === null || end === null || end <= start) return null;
          intervals.push({ start, end, closes: row.closes, opens: row.opens });
        }
        return intervals.sort((a, b) => a.start - b.start);
      }

      formatTime(value) {
        const [hours, minutes] = value.split(':').map(Number);
        return `${hours % 12 || 12}${minutes ? ':' + String(minutes).padStart(2, '0') : ''}${hours >= 12 ? 'pm' : 'am'}`;
      }

      updateStatus(now = new Date()) {
        const values = Object.fromEntries(this.clock.formatToParts(now).map(part => [part.type, part.value]));
        const date = `${values.year}-${values.month}-${values.day}`;
        const weekday = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day))).getUTCDay();
        const minutes = Number(values.hour) * 60 + Number(values.minute);
        const specialNote = this.querySelector('[data-lvu-today-special]');
        if (specialNote) {
          const special = this.specialDates.some(row => row.date === date);
          specialNote.hidden = !special;
          if (special) specialNote.textContent = this.dataset.specialLabel;
        }
        const intervals = this.intervalsFor(date, weekday);
        if (intervals === null) {
          this.statusElement.hidden = true;
          return;
        }
        let text = this.dataset.closedLabel;
        let state = 'closed';
        const active = intervals.find(interval => minutes >= interval.start && minutes < interval.end);
        if (active) {
          text = this.dataset.openLabel.replace('__TIME__', this.formatTime(active.closes));
          state = 'open';
        } else {
          const next = intervals.find(interval => minutes < interval.start);
          if (next) text = this.dataset.beforeLabel.replace('__TIME__', this.formatTime(next.opens));
        }
        this.statusText.textContent = text;
        this.statusElement.dataset.state = state;
        this.statusElement.hidden = false;
      }
    }
    customElements.define('lily-visit-us', LilyVisitUs);
  }

  } catch(e) { console.error(e); }
})();
})();
